import Skeleton from "react-loading-skeleton";

export function BillingSettingsSkeleton() {
	return (
		<div className="space-y-6">
			<div>
				<Skeleton className="h-8 w-32 mb-2" />
				<Skeleton className="h-5 w-96" />
			</div>

			<hr className="border-base-content/10" />

			{/* Payment Method Skeleton */}
			<div className="p-6 rounded-xl border border-base-content/10 bg-base-200/50">
				<div className="flex items-start gap-4">
					<Skeleton className="size-12 rounded-lg" />
					<div className="flex-1">
						<Skeleton className="h-6 w-48 mb-2" />
						<div className="flex items-center gap-4 mb-4">
							<Skeleton className="h-5 w-32" />
							<Skeleton className="h-5 w-24" />
						</div>
						<Skeleton className="h-10 w-48" />
					</div>
				</div>
			</div>

			{/* Billing Address Skeleton */}
			<div className="grid md:grid-cols-2 gap-6">
				<div>
					<Skeleton className="h-6 w-40 mb-4" />
					<div className="space-y-2">
						<Skeleton className="h-5 w-full max-w-xs" />
						<Skeleton className="h-5 w-48" />
						<Skeleton className="h-5 w-32" />
					</div>
				</div>
			</div>

			{/* Invoice History Skeleton */}
			<div>
				<Skeleton className="h-6 w-40 mb-4" />
				<div className="rounded-xl border border-base-content/10 overflow-hidden">
					<div className="p-4 border-b border-base-content/10 flex justify-between">
						<Skeleton className="h-5 w-20" />
						<Skeleton className="h-5 w-24" />
						<Skeleton className="h-5 w-32" />
						<Skeleton className="h-5 w-20" />
						<Skeleton className="h-5 w-24" />
					</div>
					{[1, 2, 3].map((i) => (
						<div
							key={i}
							className="p-4 border-b border-base-content/10 flex justify-between last:border-0"
						>
							<Skeleton className="h-5 w-20" />
							<Skeleton className="h-5 w-24" />
							<Skeleton className="h-5 w-32" />
							<Skeleton className="h-5 w-20" />
							<Skeleton className="h-5 w-24" />
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
